import React from "react";

import FilterIcon from "@mui/icons-material/Filter";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { getTranslation } from "../languageProvider";
import { ListStyled, MainIcon } from "../../theme";

export const EquipmentsDetail = ({ equipment, Edit, Delete, Copy, Select }) => {
  const editHandler = () => Edit && Edit(equipment);
  const deleteHandler = () => Delete && Delete(equipment.id);
  const selectHandler = () => Select && Select(equipment);
  const copyHandler = () => Copy && Copy(equipment);
  return (
    <ListStyled>
      <MainIcon color={equipment.state.color}>
        <img src={equipment.icon} alt={equipment.serialNumber} />
      </MainIcon>
      <div className="detail" onClick={selectHandler}>
        {equipment.serialNumber}
        <span
          className={`${!equipment.client && "error"}`}
          data-translate="0153"
        >
          {equipment.client ? equipment.client.name : getTranslation("0153")}
        </span>
      </div>
      {Copy && (
        <span className="add" onClick={copyHandler}>
          <FilterIcon />
        </span>
      )}
      {Edit && (
        <span className="edit" onClick={editHandler}>
          <EditOutlinedIcon />
        </span>
      )}
      {Delete && (
        <span className="delete" onClick={deleteHandler}>
          <DeleteOutlineOutlinedIcon />
        </span>
      )}
    </ListStyled>
  );
};
